/*
 * Public API Surface of jaakrecog-liveness-lib
 */

export * from './lib/jaakrecog-liveness-lib.service';
export * from './lib/jaakrecog-liveness-lib.component';
export * from './lib/jaakrecog-liveness-lib.module';
export * from './lib/capture-video/capture-video.component';
export * from './lib/components/loading/loading.component';
